import { useState } from "react";
import { Link, useSearchParams, useNavigate } from "react-router-dom";
import api, { formatApiErrorDetail } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";

export default function ResetPasswordPage() {
  const [params] = useSearchParams();
  const nav = useNavigate();
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const token = params.get("token") || "";
  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/auth/reset-password", { token, password });
      toast.success("Password aggiornata");
      nav("/login");
    } catch (err) { toast.error(formatApiErrorDetail(err.response?.data?.detail)); }
    finally { setLoading(false); }
  };
  return (
    <div className="min-h-screen flex items-center justify-center p-6 bg-[#F8FAFC]">
      <div className="w-full max-w-md bg-white border border-[#E2E8F0] rounded-2xl p-8">
        <h1 className="text-2xl font-bold text-stone-900 mb-6">Nuova password</h1>
        <form onSubmit={submit} className="space-y-4">
          <div><Label>Nuova password</Label><Input data-testid="reset-password-input" type="password" value={password} onChange={(e)=>setPassword(e.target.value)} required minLength={8}/></div>
          <Button type="submit" disabled={loading} className="w-full bg-[#F7941E] hover:bg-[#E08316] text-white" data-testid="reset-submit-btn">{loading?"Salvataggio...":"Aggiorna password"}</Button>
        </form>
        <div className="mt-6 text-sm"><Link to="/login" className="text-[#F7941E] hover:underline">← Torna al login</Link></div>
      </div>
    </div>
  );
}
